import { useEffect, useRef, useState } from 'react'
import { config, animated, useSpring } from 'react-spring'
import { faAngleUp, faAngleDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '#base/js/common/components/button'
import { useReportPageContext } from '#base/js/reports/contexts/report-page.context'
import { ControlBar } from './control-bar'
import { useStyles } from './page-control-bar.style'

export const PageControlBar = function ({ className = '', filterDefinition }) {
  const classes = useStyles()

  const [isDisplayOnly, setIsDisplayOnly] = useState(true)
  const [height, setHeight] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)

  const prevHeight = useRef(0)

  const reportPageContext = useReportPageContext()

  function onControlBarChange (selections, changes) {
    reportPageContext.setPageControlBarState({ selections, changes })
  }

  const transitionStyle = useSpring({
    config: { ...config.stiff, clamp: true },
    from: {
      height: prevHeight.current
    },
    to: {
      height: height
    },
    onStart: {
      height: () => setIsAnimating(true)
    },
    onRest: {
      height: () => setIsAnimating(false)
    }
  })

  useEffect(() => {
    prevHeight.current = height
  }, [height])

  return <animated.div
    className={className ? `${classes.pageControlBar} ${className}` : classes.pageControlBar}
    data-qa="page-control-bar"
    style={{
      ...transitionStyle,
      overflow: isAnimating ? 'hidden' : 'visible'
    }}
  >
    <div
      ref={(ref) => setHeight(ref?.offsetHeight)}
      className={classes.controls}
    >
      <ControlBar
        filterDefinition={filterDefinition}
        alwaysShowSelectDropdown={true}
        controlLayout="flex"
        displayOnly={isDisplayOnly}
        onChange={onControlBarChange}
      />
      <div className={classes.actions}>
        <Button
          data-qa="page-control-bar-toggle"
          className={classes.displayToggle}
          variant='icon-link'
          onClick={() => setIsDisplayOnly(!isDisplayOnly)}
        >
          {isDisplayOnly
            ? <FontAwesomeIcon icon={faAngleDown} />
            : <FontAwesomeIcon icon={faAngleUp} />}
        </Button>
      </div>
    </div>
  </animated.div>
}
